import { useState, useCallback } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

export const useModalState = (initialEvent = null) => {
    const [createEventCoords, setCreateEventCoords] = useState(null);
    const [showMyEvents, setShowMyEvents] = useState(false);
    const [selectedEvent, setSelectedEvent] = useState(initialEvent);
    const [showChangeVibe, setShowChangeVibe] = useState(false);
    const [showLanguageModal, setShowLanguageModal] = useState(false);
    const [showSuggestedGonkles, setShowSuggestedGonkles] = useState(false);

    const navigate = useNavigate();
    const { id: eventIdFromUrl } = useParams();

    const closeAllModals = useCallback(() => {
        setCreateEventCoords(null);
        setShowMyEvents(false);
        setSelectedEvent(null);
        setShowChangeVibe(false);
        setShowLanguageModal(false);
        setShowSuggestedGonkles(false);
        if (eventIdFromUrl) {
            navigate('/', { replace: true });
        }
    }, [eventIdFromUrl, navigate]);

    const handleOpenChangeVibe = useCallback(() => {
        setShowMyEvents(false);
        setShowChangeVibe(true);
    }, []);

    const handleCloseSelectedEvent = useCallback(() => {
        setSelectedEvent(null);
        if (eventIdFromUrl) {
            navigate('/', { replace: true });
        }
    }, [eventIdFromUrl, navigate]);

    return {
        createEventCoords, setCreateEventCoords,
        showMyEvents, setShowMyEvents,
        selectedEvent, setSelectedEvent,
        showChangeVibe, setShowChangeVibe,
        showLanguageModal, setShowLanguageModal,
        showSuggestedGonkles, setShowSuggestedGonkles,
        closeAllModals,
        handleOpenChangeVibe,
        handleCloseSelectedEvent,
    };
};